<script setup>
const props=defineProps({plants:{type:Array,default:()=>[]},limit:{type:Number,default:8}});
const expanded=ref(false);
const initial=computed(()=>props.plants.slice(0,props.limit));
const remaining=computed(()=>props.plants.slice(props.limit));
const sharedPrefix=computed(()=>{const word=props.plants[0]?.title?.split(' ')[0];return word&&props.plants.length>1&&props.plants.every(p=>p.title?.startsWith(word+' '))?word+' ':'';});
const label=plant=>sharedPrefix.value?plant.title.slice(sharedPrefix.value.length):plant.title;
</script>

<template>
 <div class="plant-preview-links">
  <ul class="plant-preview-list">
   <li v-for="plant in initial" :key="plant.id"><CatalogPlantPreviewLink :plant="plant" :label="label(plant)" /></li>
  </ul>
  <details v-if="remaining.length" class="plant-preview-more" @toggle="expanded=$event.target.open">
   <summary class="uo-btn uo-btn-secondary"><span>{{expanded?'Свернуть список':'Все растения ('+plants.length+')'}}</span><svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><path d="m5 7 5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg></summary>
   <ul class="plant-preview-list">
    <li v-for="plant in remaining" :key="plant.id"><CatalogPlantPreviewLink :plant="plant" :label="label(plant)" /></li>
   </ul>
  </details>
 </div>
</template>

<style scoped>
.plant-preview-links{min-width:0}
.plant-preview-list{display:flex;flex-wrap:wrap;gap:8px;list-style:none;margin:0;padding:0}
.plant-preview-list>li{min-width:0;max-width:100%;margin:0;padding:0}
.plant-preview-more{margin-top:12px}
.plant-preview-more>summary{display:inline-flex;gap:8px;min-height:44px;cursor:pointer;list-style:none;font-size:14px}
.plant-preview-more>summary::-webkit-details-marker{display:none}
.plant-preview-more[open]>summary svg{transform:rotate(180deg)}
.plant-preview-more[open]>.plant-preview-list{margin-top:12px}
.plant-preview-more>summary:focus-visible{outline:2px solid var(--uo-color-action-primaryBackground);outline-offset:4px}
@media(max-width:767px){.plant-preview-more>summary{width:100%}}
</style>
